module.exports = __webpack_public_path__ + "static/calogo-4e86412fa0bc8d7383929f524f2f5b88.jpg";